import type React from "react";

export interface RadioButtonProps {
	name: string;
	label: string | React.ReactNode;
	value: string;
	defaultChecked?: boolean;
	checked?: boolean;
	disabled?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioButton = ({
	name,
	label,
	value,
	defaultChecked = false,
	checked,
	disabled = false,
	onChange = () => {},
}: RadioButtonProps) => {
	const id = `${name}_${value}`;
	return (
		<div className="flex items-center gap-2">
			<input
				type="radio"
				className="accent-primary h-5 w-5 shrink-0"
				name={name}
				id={id}
				value={value}
				defaultChecked={defaultChecked}
				checked={checked}
				disabled={disabled}
				onChange={onChange}
			/>
			<label
				className={`${disabled ? "text-secondary-500" : "text-secondary-700"}`}
				htmlFor={id}
			>
				{label}
			</label>
		</div>
	);
};
